import { useEffect, useState } from 'react'
import dayjs from 'dayjs'

export type CountdownTimer = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

type Countdown = {
  timer: CountdownTimer
  countdown: number
}

export default function useCountdown(endTime: number, enabled: boolean): Countdown {
  const countdownEnd = +dayjs(endTime)

  const [countdown, setCountdown] = useState(countdownEnd - new Date().getTime())

  useEffect(() => {
    const activateTimer = enabled && countdownEnd - new Date().getTime() > 0

    const interval =
      activateTimer &&
      setInterval(() => {
        const timeRemaining = countdownEnd - new Date().getTime()
        setCountdown(timeRemaining)

        if (interval && timeRemaining <= 0) {
          clearInterval(interval)
        }
      }, 1000)

    if (!enabled && interval) {
      clearInterval(interval)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [countdownEnd, enabled])

  const getTimeRemaining = (countdown: number) => {
    const days = Math.floor(countdown / (1000 * 60 * 60 * 24))
    const hours = Math.floor((countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countdown % (1000 * 60)) / 1000)

    return { days, hours, minutes, seconds }
  }

  return {
    timer: getTimeRemaining(countdown),
    countdown
  }
}
